import { integrationConfigurationKeys } from "../hooks/useIntegrationConfiguration";

import { INTEGRATION_REALTIME_EVENTS } from "@/features/integrations/constants";
import type { IntegrationRealtimeEvent } from "@/features/integrations/types";
import type { ClientRealtimeFeature } from "@/features/realtime";

export const integrationsRealtime: ClientRealtimeFeature = {
  events: {
    [INTEGRATION_REALTIME_EVENTS]: async (queryClient, payload) => {
      const { integrationName } = payload as IntegrationRealtimeEvent;
      await queryClient.invalidateQueries({ queryKey: integrationConfigurationKeys.valuesOf(integrationName) });
    },
  },
  resetKey: integrationConfigurationKeys.all,
};
